export type Reference = {
  slug: string
  name: string
  url: string
  industry: string
  summary: string
  tech: string[]
  highlights: string[]
}

export const referenzen: Reference[] = [
  {
    slug: 'beda-umzuege',
    name: 'Beda Umzüge',
    url: 'https://www.beda-umzuege.de/',
    industry: 'Umzugsunternehmen',
    summary:
      'Moderne, schnelle Single‑Page‑Application mit klarer Nutzerführung und Fokus auf Conversion (Anfrage/Kontakt).',
    tech: [
      'React',
      'Vite',
      'Client‑Side Routing',
      'SPA‑Deployment (statisches Hosting)'
    ],
    highlights: [
      'Sehr schnelle Ladezeiten durch moderne Build‑Pipeline',
      'Mobil‑optimierte Oberfläche für schnelle Kontaktaufnahme',
      'Saubere Informationsstruktur für Leistungen und Angebot'
    ]
  },
  {
    slug: 'ulus-elektrotechnik',
    name: 'Ulus Elektrotechnik',
    url: 'https://www.ulus-elektrotechnik.de/',
    industry: 'Elektrotechnik',
    summary:
      'Responsiver Unternehmensauftritt mit klassischem Navigationskonzept, Leistungsseiten und Termin‑CTA.',
    tech: [
      'Bootstrap',
      'jQuery',
      'Jssor Slider',
      'Google Analytics'
    ],
    highlights: [
      'Solides, leichtgewichtiges Frontend ohne CMS‑Overhead',
      'Mehrstufige Navigation und Leistungsübersichten',
      'Schnelle Kontaktaufnahme via Termin‑CTA'
    ]
  },
  {
    slug: 'ekes-sanitaertechnik',
    name: 'EKES Sanitärtechnik',
    url: 'https://www.ekes-sanitaertechnik.de/',
    industry: 'Sanitärtechnik',
    summary:
      'CMS‑gestützte Seite mit visuell starkem Auftritt und guter Pflegebarkeit für Inhalte.',
    tech: [
      'WordPress 6.8.x',
      'Elementor',
      'WooCommerce',
      'Yoast SEO'
    ],
    highlights: [
      'Schnelle Inhaltsbearbeitung per Page‑Builder',
      'Suchmaschinenfreundliche Struktur (Yoast SEO)',
      'Komponenten‑basierte Gestaltung mit Elementor'
    ]
  },
  {
    slug: 'staisch-elektrotechnik',
    name: 'Staisch Elektrotechnik',
    url: 'https://www.staisch-elektrotechnik.de/',
    industry: 'Elektrotechnik',
    summary:
      'Klassische, schnelle Firmenseite mit Mehrseiten‑Struktur, Bild‑Carousel und Produktbereichen.',
    tech: [
      'Bootstrap',
      'jQuery',
      'PrettyPhoto'
    ],
    highlights: [
      'Übersichtliche Angebotsdarstellung in mehreren Rubriken',
      'Leichtgewichtige, robuste Umsetzung ohne schweres CMS',
      'Bewährte UI‑Patterns (Carousel, Dropdown‑Menüs)'
    ]
  }
]

